import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, IconButton } from "@mui/material";
import { useAuth } from "@ssf/auth-components";
import { getArenaGroupsFromMember } from "@ssf/memdb-api";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { Close } from "mdi-material-ui";
import { useSnackbar } from "notistack";
import { useEffect, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
const getArenaGroupRedirect = async (memberId) => getArenaGroupsFromMember(memberId, [
    { id: 1, name: 1, timeDiff: 1, filter: "(timeDiff>=0)" },
]);
const arenaGroupRedirectQuery = (memberId) => queryOptions({
    queryKey: ["arenaGroupRedirect", memberId],
    queryFn: () => getArenaGroupRedirect(memberId),
});
export const ArenaRedirect = ({ currentGroupId, actionProps, additionalGroups, }) => {
    const { t } = useTranslation("ArenaRedirect");
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const { user } = useAuth();
    const { data: memberGroups = [] } = useQuery({
        ...arenaGroupRedirectQuery(Number(user?.profile.sub)),
        enabled: !!user,
    });
    const groups = useMemo(() => [
        ...new Map([...(additionalGroups ?? []), ...memberGroups].map((group) => [
            group.id,
            group,
        ])).values(),
    ], [additionalGroups, memberGroups]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Unstable dependencies
    useEffect(() => {
        const timestampIds = groups.map((group) => {
            const day = 24 * 60 * 60 * 1000;
            if (group.timeDiff < 0 ||
                group.timeDiff > day ||
                group.id === currentGroupId) {
                return undefined;
            }
            const min15 = 15 * 60 * 1000;
            function showSnackbar() {
                const minutes = Math.floor(Math.min(group.timeDiff, min15) / 60 / 1000);
                const snackbarId = enqueueSnackbar(_jsx(Box, { children: _jsx(Trans, { t: t, i18nKey: "title", values: { name: group.name, minutes }, context: group.timeDiff > 0
                            ? "coming"
                            : group.timeDiff < 0
                                ? "ended"
                                : "started" }) }), {
                    key: group.id,
                    autoHideDuration: null,
                    action: (_jsxs(_Fragment, { children: [_jsx(Button, { size: "small", onClick: () => closeSnackbar(snackbarId), ...actionProps(group.id), children: t("action") }), _jsx(IconButton, { size: "small", color: "inherit", onClick: () => closeSnackbar(snackbarId), children: _jsx(Close, { fontSize: "small" }) })] })),
                });
            }
            if (group.timeDiff > min15) {
                return setTimeout(showSnackbar, group.timeDiff - min15);
            }
            showSnackbar();
            return undefined;
        });
        return () => {
            timestampIds.forEach((id) => id && clearTimeout(id));
            groups.forEach((group) => closeSnackbar(group.id));
        };
    }, [groups, currentGroupId]);
    return null;
};
//# sourceMappingURL=ArenaRedirect.js.map